import React from 'react';
import {observer} from 'mobx-react';
import EditContactInfoModal from './EditContactInfoModal';
import {t} from 'shared/core';
import InfoPanel from './InfoPanel';

const ATTRIBUTES = [
  {
    label: 'employees.profile.personal.Work Email',
    render: ({employee}) => employee.workEmail
  },
  {
    label: 'employees.profile.personal.Personal Email',
    render: ({employee}) => employee.personalEmail
  },
  {
    label: 'employees.profile.personal.Work Phone',
    render: ({employee}) => employee.workPhone
  },
  {
    label: 'employees.profile.personal.Work Phone Extension',
    render: ({employee}) => employee.workPhoneExtension
  },
  {
    label: 'employees.profile.personal.Personal Phone',
    render: ({employee}) => employee.personalPhone
  },
];

const ContactInformation = observer(({uiState}) => {
  const {employee} = uiState;

  return (
    <>
      <InfoPanel
        employee={employee}
        canEdit={uiState.editDataPermission('::PERSONAL_INFORMATION')}
        onEdit={() => uiState.openContactInfoModal()}
        title={t('employees.profile.personal.Contact Information')}
        attributes={ATTRIBUTES}
      />
      <EditContactInfoModal uiState={uiState} />
    </>
  );
});

export default ContactInformation;
